(function() {
  'use strict';

  function processArticleContent() {
    const contentInner = document.querySelector('.article__content-inner');
    if (!contentInner) {
      return;
    }

    
    if (contentInner.classList.contains('processed') && 
        !contentInner.querySelector('.blog-content, .content-flex-wrapper, .content-block-wrapper')) {
      return;
    }

    
    let contentContainer = contentInner;
    const blogContent = contentInner.querySelector('.blog-content');
    if (blogContent) {
      contentContainer = blogContent;
    }

    
    const articleTitle = document.querySelector('.article__title')?.textContent?.trim();
    
    if (articleTitle) {
      
      const allHeadings = contentContainer.querySelectorAll('h1, h2, h3, h4, h5, h6');
      allHeadings.forEach(heading => {
        
        if (heading.closest('.content-flex-wrapper, .content-block-wrapper, .blog-section, .blog-split')) {
          return;
        }
        
        if (heading.textContent.trim() === articleTitle) {
          heading.remove();
        }
      });
    }

    
    const heroImg = document.querySelector('.article__hero img');
    if (heroImg) {
      const allImages = contentContainer.querySelectorAll('img');
      allImages.forEach(img => {
        
        if (img.closest('.blog-slider, .slider-track, .slide')) {
          return;
        }
        
        if (img.src === heroImg.src || img.getAttribute('src') === heroImg.getAttribute('src')) {
          const parent = img.closest('p, div');
          if (parent && parent.textContent.trim() === '') {
            parent.remove();
          } else if (img.parentNode) {
            img.remove();
          }
        }
      });
    }

    
    let children = Array.from(contentContainer.children);
    
    
    children = children.filter(child => 
      child.tagName !== 'STYLE' && 
      child.tagName !== 'SCRIPT' &&
      !child.classList.contains('content-flex-wrapper') &&
      !child.classList.contains('content-block-wrapper') &&
      !child.classList.contains('blog-section') &&
      !child.classList.contains('blog-split')
    );

    if (children.length === 0) {
      contentInner.classList.add('processed');
      return;
    }

    let processedIndex = 0;
    let layoutType = 'block'; 
    let foundFirstText = false;

    
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (!child) continue;
      
      if (child.classList.contains('blog-slider') || child.querySelector('.blog-slider')) continue;
      
      if ((child.tagName === 'P' || child.tagName === 'DIV') && 
          !child.querySelector('img') && 
          child.textContent.trim() !== '') {
        const section = document.createElement('section');
        section.className = 'blog-section blog-section-intro';
        const p = document.createElement('p');
        p.className = 'blog-section-paragraph';
        p.innerHTML = child.innerHTML;
        section.appendChild(p);
        child.parentNode.replaceChild(section, child);
        foundFirstText = true;
        processedIndex = i + 1;
        break;
      }
    }

    
    while (processedIndex < children.length) {
      
      children = Array.from(contentContainer.children).filter(child => 
        child.tagName !== 'STYLE' && 
        child.tagName !== 'SCRIPT' &&
        !child.classList.contains('content-flex-wrapper') &&
        !child.classList.contains('content-block-wrapper') &&
        !child.classList.contains('blog-section') &&
        !child.classList.contains('blog-split')
      );
      
      if (processedIndex >= children.length) break;

      const current = children[processedIndex];
      if (!current || !current.parentNode) {
        processedIndex++;
        continue;
      }

      
      if (current.classList.contains('blog-slider') || current.querySelector('.blog-slider')) {
        processedIndex++;
        continue;
      }

      
      if (current.classList.contains('content-flex-wrapper') || 
          current.classList.contains('content-block-wrapper') ||
          current.classList.contains('blog-section') ||
          current.classList.contains('blog-split') ||
          current.classList.contains('processed')) {
        processedIndex++;
        continue;
      }

      const hasImage = current.querySelector('img') || current.tagName === 'IMG';
      
      if (hasImage && current.querySelector('.blog-slider, .slider-track')) {
        processedIndex++;
        continue;
      }

      const nextElement = children[processedIndex + 1];
      const nextHasImage = nextElement && (nextElement.querySelector('img') || nextElement.tagName === 'IMG');
      
      if (nextElement && (nextElement.classList.contains('blog-slider') || nextElement.querySelector('.blog-slider'))) {
        processedIndex++;
        continue;
      }
      
      const nextIsText = nextElement && (nextElement.tagName === 'P' || nextElement.tagName === 'DIV' || 
                                         nextElement.tagName === 'H2' || nextElement.tagName === 'H3' || 
                                         nextElement.tagName === 'H4') &&
                                         !nextElement.querySelector('img');
      const isHeading = current.tagName === 'H2' || current.tagName === 'H3' || current.tagName === 'H4';

      
      
      const isImageOnly = hasImage && (
        current.tagName === 'IMG' || 
        current.classList.contains('image-container') ||
        (current.textContent.trim() === '' && current.querySelector('img') && 
         !current.querySelector('img').nextSibling && !current.querySelector('img').previousSibling)
      );
      
      
      const canDoFlex = isImageOnly && nextIsText && !nextHasImage;
      const canDoBlock = isHeading && nextHasImage;
      
      
      const shouldDoFlex = (layoutType === 'flex' && canDoFlex) || (layoutType === 'block' && !canDoBlock && canDoFlex);
      
      if (shouldDoFlex) {
        
        const split = document.createElement('section');
        split.className = 'blog-split';
        
        const splImg = document.createElement('img');
        if (current.tagName === 'IMG') {
          splImg.src = current.src;
          splImg.alt = current.alt || '';
          current.remove();
        } else {
          const img = current.querySelector('img');
          if (img) {
            splImg.src = img.src;
            splImg.alt = img.alt || '';
            if (current.classList.contains('image-container') || (current.textContent.trim() === '' && !current.querySelector('*:not(img)'))) {
              current.remove();
            } else {
              img.remove();
            }
          }
        }
        splImg.className = 'blog-split-image';
        split.appendChild(splImg);

        const textDiv = document.createElement('div');
        textDiv.className = 'blog-split-text';
        if (nextElement) {
          const tag = nextElement.tagName === 'H2' || nextElement.tagName === 'H3' || nextElement.tagName === 'H4' ? 'h2' : 'p';
          const el = document.createElement(tag);
          el.className = tag === 'h2' ? 'blog-section-title' : 'blog-section-paragraph';
          el.innerHTML = nextElement.innerHTML;
          textDiv.appendChild(el);
          nextElement.remove();
          const nextNext = children[processedIndex + 2];
          if (nextNext && (nextNext.tagName === 'P' || nextNext.tagName === 'DIV') && !nextNext.querySelector('img') && !nextNext.classList.contains('blog-slider')) {
            const p = document.createElement('p');
            p.className = 'blog-section-paragraph';
            p.innerHTML = nextNext.innerHTML;
            textDiv.appendChild(p);
            nextNext.remove();
          }
        }
        split.appendChild(textDiv);

        const insertBefore = children[processedIndex];
        if (insertBefore && insertBefore.parentNode) {
          insertBefore.parentNode.insertBefore(split, insertBefore);
        } else {
          contentContainer.appendChild(split);
        }
        if (current.parentNode) current.remove();
        
        layoutType = 'block';
        processedIndex += 2;
        continue;
      }

      
      
      const shouldDoBlock = (layoutType === 'block' && canDoBlock) || (layoutType === 'flex' && !canDoFlex && canDoBlock);
      
      if (shouldDoBlock) {
        
        const section = document.createElement('section');
        section.className = 'blog-section';
        
        const h2 = document.createElement('h2');
        h2.className = 'blog-section-title';
        h2.innerHTML = current.innerHTML;
        section.appendChild(h2);
        current.remove();
        
        if (nextElement) {
          const imgEl = document.createElement('img');
          if (nextElement.tagName === 'IMG') {
            imgEl.src = nextElement.src;
            imgEl.alt = nextElement.alt || '';
            nextElement.remove();
          } else {
            const img = nextElement.querySelector('img');
            if (img) {
              imgEl.src = img.src;
              imgEl.alt = img.alt || '';
              if (nextElement.classList.contains('image-container') || (nextElement.textContent.trim() === '' && !nextElement.querySelector('*:not(img)'))) {
                nextElement.remove();
              } else {
                img.remove();
              }
            }
          }
          imgEl.className = 'blog-section-image';
          section.appendChild(imgEl);
        }

        const insertBefore = children[processedIndex];
        if (insertBefore && insertBefore.parentNode) {
          insertBefore.parentNode.insertBefore(section, insertBefore);
        } else {
          contentContainer.appendChild(section);
        }
        
        layoutType = 'flex';
        processedIndex += 2;
        continue;
      }

      
      if (!hasImage && (current.tagName === 'P' || current.tagName === 'DIV') && 
          !current.classList.contains('blog-split-text') &&
          !current.classList.contains('blog-slider') &&
          current.textContent.trim() !== '') {
        if (!foundFirstText || processedIndex > 0) {
          const section = document.createElement('section');
          section.className = 'blog-section';
          const p = document.createElement('p');
          p.className = 'blog-section-paragraph';
          p.innerHTML = current.innerHTML;
          section.appendChild(p);
          current.parentNode.replaceChild(section, current);
        }
        processedIndex++;
        continue;
      }

      
      if (hasImage && !current.querySelector('.blog-slider')) {
        let isLastImage = true;
        for (let i = processedIndex + 1; i < children.length; i++) {
          if (children[i] && (children[i].querySelector('img') || children[i].tagName === 'IMG') &&
              !children[i].querySelector('.blog-slider')) {
            isLastImage = false;
            break;
          }
        }

        if (isLastImage) {
          
          if (current.tagName === 'IMG') {
            current.classList.add('blog-full-image');
          } else {
            const img = current.querySelector('img');
            if (img) img.classList.add('blog-full-image');
            current.classList.add('blog-full-image-wrapper');
          }
        } else {
          
          if (current.tagName === 'IMG') {
            current.style.paddingInline = '43px';
          } else {
            current.style.paddingInline = '43px';
          }
        }
        processedIndex++;
        continue;
      }

      processedIndex++;
    }

    
    if (blogContent) {
      blogContent.style.paddingInline = '';
      blogContent.style.marginBlockEnd = '';
    }

    
    contentInner.classList.add('processed');
  }

  
  function init() {
    processArticleContent();
    setTimeout(processArticleContent, 100);
    setTimeout(processArticleContent, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  
  window.addEventListener('load', processArticleContent);
})();
